module.exports = function() {
  return new Worker(__webpack_public_path__ + "ca4cd8cb2cff86444b9b.worker.js");
};